import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=dd09e428&scoped=true"
import script from "./StockCard.vue?vue&type=script&lang=js"
export * from "./StockCard.vue?vue&type=script&lang=js"
import style0 from "./StockCard.vue?vue&type=style&index=0&id=dd09e428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd09e428",
  null
  
)

export default component.exports